<template>
  <div class="bg-white">
    <div class="flex items-center justify-between">
      <div class="text-xl font-semibold py-6">Privacy Policy</div>
      <div @click="close">
        <close-icon :width="'w-4'" :height="'h-4'"></close-icon>
      </div>
    </div>
    <div class="max-h-full overflow-y-scroll">
      <div class="max-h-90-screen">
        <div class="text-left">
          <div class="font-bold uppercase pb-2">Effective date: 17-06-2021</div>
          <div class="font-bold uppercase pb-2"><span class="pr-3">1.</span> Introduction</div>
          <div class="text-sm text-justify">Welcome to Northwing Logistics Limited.</div>
          <div class="text-sm text-justify py-2">
            Northwing Logistics Limited (“us”, “we”, or “our”) operates northwinglogistics.com (hereinafter referred to
            as the “Site”).
          </div>
          <div class="text-sm text-justify py-2">
            Our Privacy Policy governs your visit to northwinglogistics.com. It explains how we use the information we
            collect about you, how you can instruct us if you prefer to limit the use of that information and procedures
            that we have in place to safeguard your privacy. This Privacy Policy has been compiled to better serve those
            who are concerned with how their 'Personal Data’ is being used on the Site.
          </div>
          <div class="text-sm text-justify py-2">
            By using the Site, you agree to the collection and use of information in accordance with this Policy. Unless
            otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in
            our Terms and Conditions.
          </div>
          <div class="text-sm text-justify py-2">
            Our Terms and Conditions (“Terms”) govern all use of our Site and together with the Privacy Policy,
            constitutes your agreement with us (the “Agreement”).
          </div>
          <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">2.</span>Definitions</div>
          <div class="text-sm text-justify">
            Site means the northwinglogistics.com website operated by Northwing Logistics Limited.
          </div>
          <div class="text-sm text-justify py-2">
            Personal data means data about a living individual who can be identified from those data (or from those and
            other information either in our possession or likely to come into our possession).
          </div>
          <div class="text-sm text-justify py-2">
            Usage data is data collected automatically either generated by the use of the Site or from the Site’s
            infrastructure itself (for example, the duration of a page visit).
          </div>
          <div class="text-sm text-justify py-2">
            Cookies are small files stored on your device (computer or mobile device).
          </div>
          <div class="text-sm text-justify py-2">
            Data processors (or service providers) mean any natural or legal person who processes the data on behalf of
            the Data Controller. We may use the services of various Service Providers in order to process your data more
            effectively.
          </div>
          <div class="text-sm text-justify py-2">
            Data subject is any living individual who is the subject of Personal Data.
          </div>
          <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">3.</span>Information Collection and Use</div>
          <div class="text-sm text-justify">
            We collect several different types of information for various purposes to provide and improve our Service to
            you.
          </div>
          <div class="font-bold uppercase pt-4 pb-2"><span class="pr-3">4.</span>Types of Data Collected</div>
          <div class="font-bold capitalize pt-1 pb-2">Personal Data</div>
          <div class="text-sm text-justify pb-1">
            While using our Site, we may ask you to provide us with certain personally identifiable information that can
            be used to contact or identify you (“Personal Data”). Personally, identifiable information may include, but
            is not limited to:
          </div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">01.</div>
              <div>Email address</div>
            </div>
            <div class="flex">
              <div class="pr-2">02.</div>
              <div>First name and last name</div>
            </div>
            <div class="flex">
              <div class="pr-2">03.</div>
              <div>Phone number</div>
            </div>
            <div class="flex">
              <div class="pr-2">04.</div>
              <div>Address, Country, City, State, ZIP/Postal code</div>
            </div>
            <div class="flex">
              <div class="pr-2">05.</div>
              <div>Cookies and Usage Data</div>
            </div>
          </div>
          <div class="text-sm text-justify pb-1">
            We may use your Personal Data to contact you with newsletters, marketing or promotional materials and other
            information that may be of interest to you. You may opt out of receiving any, or all, of these
            communications from us by following the unsubscribe link. In addition to the above, your Personal data may
            also be collected when you voluntarily provide such information, such as when you contact us with inquiries,
            respond to one of our surveys, provide feedback, or register for access to the services on the Site.
          </div>
          <div class="font-bold capitalize pt-1 pb-2">Usage Data</div>
          <div class="text-sm text-justify pb-2">
            We may also collect information that your browser sends whenever you visit our Site or when you access the
            Site by or through any device (“Usage Data”).
          </div>
          <div class="text-sm text-justify pb-2">
            This Usage Data may include information such as your computer’s Internet Protocol address (e.g., IP
            address), browser type, browser version, the pages of our Site that you visit, the time and date of your
            visit, the time spent on those pages, unique device identifiers and other diagnostic data.
          </div>
          <div class="text-sm text-justify pb-2">
            When you access the Site with a device, this Usage Data may include information such as the type of device
            you use, your device unique ID, the IP address of your device, your device operating system, the type of
            Internet browser you use, unique device identifiers and other diagnostic data.
          </div>
          <div class="font-bold capitalize pt-1 pb-2">Location Data</div>
          <div class="text-sm text-justify pb-2">
            We may use and store information about your location if you give us permission to do so (“Location Data”).
            We use this data to provide features of our Site, to improve and customize our Site.
          </div>
          <div class="text-sm text-justify pb-2">
            You can enable or disable location services when you use our Site at any time by way of your device
            settings.
          </div>
          <div class="font-bold capitalize pt-1 pb-2">Cookies Data</div>
          <div class="text-sm text-justify pb-2">
            In operating the Site, we may use a technology called "Cookies". A Cookie is a piece of information that the
            computer that hosts our Site gives to your browser when you access the Site. Our Cookies help provide
            additional functionality to the Site and help us analyse Site usage more accurately. In all cases in which
            we use Cookies, we will not collect Personal Data except with your permission or use information gathered
            for tracking purposes.
          </div>
          <div class="text-sm text-justify pb-2">
            You can instruct your browser to refuse all cookies or to indicate when a Cookie is being sent. However, if
            you do not accept Cookies, you may not be able to use some portions of our Site. Examples of Cookies we use:
          </div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">a.</div>
              <div>Session Cookies: We use Session Cookies to operate our Site.</div>
            </div>
            <div class="flex">
              <div class="pr-2">b.</div>
              <div>
                Preference Cookies: We use Preference Cookies to remember your preferences and various settings.
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">c.</div>
              <div>Security Cookies: We use Security Cookies for security purposes.</div>
            </div>
            <div class="flex">
              <div class="pr-2">d.</div>
              <div>
                Advertising Cookies: Advertising Cookies are used to serve you with advertisements that may be relevant
                to you and your interests.
              </div>
            </div>
          </div>
          <div class="font-bold capitalize pt-1 pb-2">Other Data</div>
          <div class="text-sm text-justify pb-2">
            While using our Site, we may also collect the following information: sex, age, date of birth, place of
            birth, passport details, citizenship, registration at place of residence and actual address, telephone
            number (work, mobile), national identity number (or other taxpayer identification) number, office location
            and other data.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">5.</span>Use of Data and Other Information</div>
          <div class="text-sm text-justify pb-2">Northwing logistics uses the collected data for various purposes:</div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">a.</div>
              <div>to notify you about changes to our Site.</div>
            </div>
            <div class="flex">
              <div class="pr-2">b.</div>
              <div>to allow you to participate in interactive features of our Site when you choose to do so;</div>
            </div>
            <div class="flex">
              <div class="pr-2">c.</div>
              <div>to monitor the usage of our Site;</div>
            </div>
            <div class="flex">
              <div class="pr-2">d.</div>
              <div>to detect, prevent and address technical issues;</div>
            </div>
            <div class="flex">
              <div class="pr-2">e.</div>
              <div>to fulfil any other purpose for which you provide it;</div>
            </div>
            <div class="flex">
              <div class="pr-2">f.</div>
              <div>
                to carry out our obligations and enforce our rights arising from any contracts entered into between you
                and us, including for billing and collection;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">g.</div>
              <div>
                to personalize your experience and to allow us to deliver the type of content and product offerings in
                which you are most interested;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">h.</div>
              <div>to allow us to better serve you in responding to your customer service requests;</div>
            </div>
            <div class="flex">
              <div class="pr-2">i.</div>
              <div>to quickly process your transactions;</div>
            </div>
            <div class="flex">
              <div class="pr-2">j.</div>
              <div>to follow up with you after correspondence (email or phone inquiries);</div>
            </div>
            <div class="flex">
              <div class="pr-2">k.</div>
              <div>to help us develop the Site and our services;</div>
            </div>
            <div class="flex">
              <div class="pr-2">l.</div>
              <div>
                to provide your information to our customer service agencies for research and analysis purposes so that
                we can monitor and improve the services we provide. We or our agents and sub-contractors may contact you
                by e-mail or telephone to ask you for your feedback and comments on our services;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">m.</div>
              <div>
                to provide you with information about special features of our Site or any other service or products we
                think may be of interest to you;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">n.</div>
              <div>
                to provide you with related information from third parties we think may be of interest to you unless you
                have opted not to receive such information;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">o.</div>
              <div>
                to provide your information to carefully selected third parties whose products or services we believe
                may be of interest to you. These third-party sites have separate and independent privacy policies. We
                therefore have no responsibility or liability for the content and activities of these linked sites. We
                seek to protect the integrity of our site and welcome any feedback about these sites.
              </div>
            </div>
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">6.</span>Retention of Data</div>
          <div class="text-sm text-justify pb-2">
            We will retain your Personal Data only for as long as is necessary for the purposes set out in this Privacy
            Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal
            obligations (for example, if we are required to retain your data to comply with applicable laws), resolve
            disputes, and enforce our legal agreements and policies.
          </div>
          <div class="text-sm text-justify pb-2">
            We will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a
            shorter period, except when this data is used to strengthen the security or to improve the functionality of
            our Site, or we are legally obligated to retain this data for longer time periods.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">7.</span>Transfer of Data</div>
          <div class="text-sm text-justify pb-2">
            Your information, including Personal Data, may be transferred to – and maintained on – computers located
            outside of your state, province, country or other governmental jurisdiction where the data protection laws
            may differ from those of your jurisdiction.
          </div>
          <div class="text-sm text-justify pb-2">
            If you are located outside Nigeria and choose to provide information to us, please note that we transfer the
            data, including Personal Data, to Nigeria and process it there.
          </div>
          <div class="text-sm text-justify pb-2">
            Your consent to this Privacy Policy followed by your submission of such information represents your
            agreement to that transfer.
          </div>
          <div class="text-sm text-justify pb-2">
            Northwing Logistics Limited will take all the steps reasonably possible to ensure that your data is treated
            securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to
            an organisation or a country unless there are adequate controls in place including the security of your data
            and other personal information.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">8.</span>Disclosure of Data</div>
          <div class="text-sm text-justify pb-2">
            Northwing Logistics Limited is not in the business of selling your information. We consider this information
            to be a vital part of our relationship with you. There are, however, certain circumstances in which we may
            share your Personal Data with certain third parties without further notice to you, as set forth below:
          </div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">a.</div>
              <div class="font-semibold">
                Legal Requirement.
                <div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>comply with a legal obligation;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>protect and defend the rights or property of Northwing Logistics Limited;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>
                      act in urgent circumstances to protect the personal safety of users of our Site and the public; or
                    </div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>protect against legal liability.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">b.</div>
              <div>
                <span class="font-semibold">Business Transfers.</span>
                <div class="text-sm text-justify pb-2">
                  If we or our subsidiaries are involved in a merger, acquisition, dissolution, reorganization, asset
                  sale, or similar event, your Personal Data may be part of the transferred assets.
                </div>
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">c.</div>
              <div class="font-semibold">
                Other cases. We may disclose your information also:
                <div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>To our subsidiaries and affiliates;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>
                      To contractors, service providers, and other third parties we use to support our business;
                    </div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>To fulfill the purpose for which you provide it;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>For the purpose of including your company’s logo on our website;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>For any other purpose disclosed by us when you provide the information;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>With your consent in any other cases;</div>
                  </div>
                  <div class="flex">
                    <div class="mr-3 py-px text-xs">o</div>
                    <div>
                      If we believe disclosure is necessary or appropriate to protect the rights, property, or safety of
                      the Company, our customers, or others.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">9.</span>Security of Data</div>
          <div class="text-sm text-justify pb-2">
            The security of your data is important to us but remember that no method of transmission over the Internet
            or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to
            protect your Personal Data, we cannot guarantee its absolute security.
          </div>
          <div class="font-bold uppercase pt-4 py-2">
            <span class="pr-3">10.</span>Your Data Protection Rights Under Nigeria Data Protection Regulation (NDPR)
          </div>
          <div class="text-sm text-justify pb-2">
            If you are a resident of Nigeria, the jurisdiction that governs our operations, you have certain data
            protection rights, covered by NDPR which include:
          </div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">a.</div>
              <div>the right to be informed of the actual or intended Processing activity;</div>
            </div>
            <div class="flex">
              <div class="pr-2">b.</div>
              <div>the right to rectify the Personal Data;</div>
            </div>
            <div class="flex">
              <div class="pr-2">c.</div>
              <div>the right to object to the Processing of Personal Data;</div>
            </div>
            <div class="flex">
              <div class="pr-2">d.</div>
              <div>the right to request the deletion of Personal Data;</div>
            </div>
            <div class="flex">
              <div class="pr-2">e.</div>
              <div>the right to request the restriction of the Processing of Personal Data; and</div>
            </div>
            <div class="flex">
              <div class="pr-2">f.</div>
              <div>
                the right to request that Personal Data be transferred to another platform or person (natural or
                artificial).
              </div>
            </div>
          </div>
          <div class="text-sm text-justify pb-2">
            If you wish to be informed what Personal Data, we hold about you and if you want it to be removed from our
            systems, please email us at
            <a class="underline text-indigo-600" href="mailto:enquiries@northwinglogistics.com"
              >enquiries@northwinglogistics.com</a
            >
          </div>
          <div class="text-sm text-justify pb-2">
            Please note that we may ask you to verify your identity before responding to such requests. Please note, we
            may not be able to provide the Site without some necessary data.
          </div>
          <div class="font-bold uppercase pt-4 py-2">
            <span class="pr-3">11.</span>Your Data Protection Rights Under General Data Protection Regulation (GDPR)
          </div>
          <div class="text-sm text-justify pb-2">
            If you are a resident of the European Union (EU) and European Economic Area (EEA), you have certain data
            protection rights, covered by GDPR.
          </div>
          <div class="text-sm text-justify pb-2">
            We aim to take reasonable steps to allow you to correct, amend, delete, or limit the use of your Personal
            Data.
          </div>
          <div class="text-sm text-justify pb-2">
            If you wish to be informed what Personal Data, we hold about you and if you want it to be removed from our
            systems, please email us at
            <a class="underline text-indigo-600" href="mailto:support@northwinglogistics.com"
              >support@northwinglogistics.com</a
            >
          </div>
          <div class="text-sm text-justify pb-2">
            In certain circumstances, you have the following data protection rights:
          </div>
          <div class="text-sm text-justify pb-2">
            <div class="flex">
              <div class="pr-2">a.</div>
              <div>The right to access, update or to delete the information we have on you;</div>
            </div>
            <div class="flex">
              <div class="pr-2">b.</div>
              <div>
                The right of rectification. You have the right to have your information rectified if that information is
                inaccurate or incomplete;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">c.</div>
              <div>The right to object. You have the right to object to our processing of your Personal Data;</div>
            </div>
            <div class="flex">
              <div class="pr-2">d.</div>
              <div>
                The right of restriction. You have the right to request that we restrict the processing of your personal
                information;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">e.</div>
              <div>
                The right to data portability. You have the right to be provided with a copy of your Personal Data in a
                structured, machine-readable and commonly used format;
              </div>
            </div>
            <div class="flex">
              <div class="pr-2">f.</div>
              <div>
                The right to withdraw consent. You also have the right to withdraw your consent at any time where we
                rely on your consent to process your personal information.
              </div>
            </div>
          </div>
          <div class="text-sm text-justify pb-2">
            Please note that we may ask you to verify your identity before responding to such requests. Please note, we
            may not able to provide the Site without some necessary data.
          </div>
          <div class="text-sm text-justify pb-2">
            You have the right to complain to a Data Protection Authority about our collection and use of your Personal
            Data. For more information, please contact your local data protection authority in the European Economic
            Area (EEA).
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">12.</span>Service Providers</div>
          <div class="text-sm text-justify pb-2">
            We may employ third party companies and individuals to facilitate our Site (“Service Providers”), provide
            the Site on our behalf, perform Site-related services or assist us in monitoring and analysing how our Site
            is used.
          </div>
          <div class="text-sm text-justify pb-2">
            These third parties have access to your Personal Data only to perform these tasks on our behalf and are
            obligated not to disclose or use it for any other purpose.
          </div>
          <div class="font-bold uppercase pt-4 py-2">
            <span class="pr-3">13.</span>CI/CD (Continuous Integration/Continuous Delivery) Tools
          </div>
          <div class="text-sm text-justify pb-2">
            We may use third-party Service Providers to automate the development process of our Service.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">14.</span>Behavioral Remarketing</div>
          <div class="text-sm text-justify pb-2">
            We may use remarketing services to advertise on third party websites to you after you visited our Site. We
            and our third-party vendors use cookies to inform, optimise and serve ads based on your past visits to our
            Site.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">15.</span>Payments</div>
          <div class="text-sm text-justify pb-2">
            We may provide paid products and/or services within the Site. In that case, we use third-party services for
            payment processing (e.g. payment processors).
          </div>
          <div class="text-sm text-justify pb-2">
            We will not store or collect your payment card details. That information is provided directly to our
            third-party payment processors whose use of your personal information is governed by their privacy policy.
            These payment processors adhere to the standards set by PCI-DSS (Payment Card Industry Data Security
            Standard) as managed by the PCI Security Standards Council, which is a joint effort of brands like Visa,
            Mastercard, American Express and Discover. PCI-DSS requirements help ensure the secure handling of payment
            information.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">16.</span>Links to Other Sites</div>
          <div class="text-sm text-justify pb-2">
            Our Site may contain links to other sites that are not operated by us. If you click a third party link, you
            will be directed to that third party’s site. We strongly advise you to review the privacy policy of every
            site you visit.
          </div>
          <div class="text-sm text-justify pb-2">
            We have no control over and assume no responsibility for the content, privacy policies or practices of any
            third party sites or services.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">17.</span>Children’s Privacy</div>
          <div class="text-sm text-justify pb-2">
            Our Services are not intended for use by children under the age of 18 (“Child” or “Children”).
          </div>
          <div class="text-sm text-justify pb-2">
            We do not knowingly collect personally identifiable information from Children under 18. If you become aware
            that a Child has provided us with Personal Data, please contact us. If we become aware that we have
            collected Personal Data from Children without verification of parental consent, we take steps to remove that
            information from our servers.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">18.</span>Changes to This Privacy Policy</div>
          <div class="text-sm text-justify pb-2">
            By submitting your information, you consent to the use of that information as set out in this Policy. The
            Website and our business may change from time to time. As a result, at times it may be necessary for
            Northwing Logistics Limited to make changes to this Privacy Policy. Northwing Logistics Limited reserves the
            right to update or modify this Privacy Policy at any time and from time to time without prior notice. Please
            review this Policy periodically, and especially before you provide any Personal Data. This Privacy Policy
            was last updated on the date indicated above. If we change our Privacy Policy, we will post the changes on
            this page and may place notice on other pages of the Site, so that you may be aware of the information we
            collect and how we use it all times.
          </div>
          <div class="text-sm text-justify pb-2">
            We will also e-mail you should we make any changes so that you may consent to our use of your information in
            that way. Continued use of the Site will signify that you agree to any such changes
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">19.</span>Remedies for Breach</div>
          <div class="text-sm text-justify pb-2">
            In the case of a breach of any of the obligations with respect to your Personal Data, a data breach
            procedure is established and maintained in order to deal with incidents concerning Personal Data or privacy
            practices leading to the accidental or unlawful destruction, loss, alteration, unauthorized disclosure of,
            or access to, Personal Data transmitted, stored or otherwise processed. On notification of such breach,
            Northwing Logistics Limited will investigate to determine if an actual breach has occurred, the actions
            required to manage such breach, communicate with the subject of the breach and take appropriate action as
            will be agreed between Northwing Logistics Limited and the subject of the breach to compensate the subject
            for such breach within one month of notification of breach.
          </div>
          <div class="font-bold uppercase pt-4 py-2"><span class="pr-3">20.</span>Contact us</div>
          <div class="text-sm text-justify pb-6">
            If you have any questions about this Privacy Policy, please contact us by email:
            <a class="underline text-indigo-600" href="mailto:enquiries@northwinglogistics.com"
              >enquiries@northwinglogistics.com</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseIcon from '../components/icons/CloseIcon.vue'
export default {
  components: { CloseIcon },
  methods: {
    close() {
      this.$emit('privacy-policy', false)
    }
  }
}
</script>

<style></style>
